<template>
  <div class="detail-panel">
    <!-- body -->
    <header
      class="d-flex flex-row flex-justify-between flex-items-center w-100"
    >
      <svg
        class="c-pointer"
        id="close"
        viewBox="0 0 12 12"
        fill="none"
        style="height: 30px; width: 30px"
        @click="onClose"
      >
        <path
          d="M7.15006 6.09038C7.13842 6.07876 7.12919 6.06497 7.12289 6.04978C7.11658 6.0346 7.11334 6.01832 7.11334 6.00188C7.11334 5.98543 7.11658 5.96915 7.12289 5.95397C7.12919 5.93878 7.13842 5.92499 7.15006 5.91338L11.7816 1.28238C11.9222 1.14155 12.0011 0.950619 12.001 0.751596C12.0008 0.552573 11.9216 0.361757 11.7808 0.221126C11.64 0.0804952 11.4491 0.00156852 11.25 0.00170917C11.051 0.00184982 10.8602 0.0810463 10.7196 0.221876L6.08856 4.85088C6.07695 4.86252 6.06316 4.87175 6.04797 4.87805C6.03279 4.88436 6.01651 4.8876 6.00006 4.8876C5.98362 4.8876 5.96734 4.88436 5.95216 4.87805C5.93697 4.87175 5.92317 4.86252 5.91156 4.85088L1.28056 0.221876C1.21093 0.15221 1.12826 0.0969412 1.03726 0.0592255C0.946271 0.0215099 0.84874 0.00208593 0.75024 0.00206271C0.551311 0.00201583 0.360511 0.0809952 0.219814 0.221626C0.0791162 0.362257 4.6905e-05 0.55302 2.08617e-08 0.751949C-4.68632e-05 0.950879 0.0789325 1.14168 0.219564 1.28238L4.85006 5.91338C4.8617 5.92499 4.87094 5.93878 4.87724 5.95397C4.88354 5.96915 4.88679 5.98543 4.88679 6.00188C4.88679 6.01832 4.88354 6.0346 4.87724 6.04978C4.87094 6.06497 4.8617 6.07876 4.85006 6.09038L0.219564 10.7219C0.14993 10.7915 0.0947003 10.8742 0.0570276 10.9653C0.0193548 11.0563 -2.31938e-05 11.1538 2.08617e-08 11.2523C4.6905e-05 11.4512 0.0791162 11.642 0.219814 11.7826C0.28948 11.8523 0.372179 11.9075 0.46319 11.9452C0.554201 11.9828 0.651741 12.0022 0.75024 12.0022C0.94917 12.0021 1.13993 11.9231 1.28056 11.7824L5.91156 7.15088C5.92317 7.13924 5.93697 7.13 5.95216 7.1237C5.96734 7.1174 5.98362 7.11415 6.00006 7.11415C6.01651 7.11415 6.03279 7.1174 6.04797 7.1237C6.06316 7.13 6.07695 7.13924 6.08856 7.15088L10.7196 11.7824C10.8602 11.9231 11.051 12.0021 11.2499 12.0022C11.4488 12.0022 11.6396 11.9233 11.7803 11.7826C11.921 11.642 12.0001 11.4512 12.0001 11.2523C12.0002 11.0534 11.9212 10.8626 11.7806 10.7219L7.15006 6.09038Z"
          fill="black"
        />
      </svg>
    </header>
    <slot />
  </div>
</template>

<script>
export default {
  name: "DetailPanel",

  props: {
    fullBody: Boolean,
  },

  methods: {
    onClose() {
      this.$router.push({ name: "main" });
    },
  },
};
</script>

<style lang="scss">
.detail-panel {
  top: 0;
  z-index: 9999;
  position: fixed;
  right: 0;
  bottom: 0;
  width: 700px;
  background-color: #fff;

  box-shadow: -5px 0 30px rgba(0, 0, 0, 0.1);

  &-header {
    display: flex;
    align-items: center;
  }
}
</style>
